import { render, staticRenderFns } from "./OrderShipmentCreate.vue?vue&type=template&id=1f46f11c&"
import script from "./OrderShipmentCreate.vue?vue&type=script&lang=js&"
export * from "./OrderShipmentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f46f11c')) {
      api.createRecord('1f46f11c', component.options)
    } else {
      api.reload('1f46f11c', component.options)
    }
    module.hot.accept("./OrderShipmentCreate.vue?vue&type=template&id=1f46f11c&", function () {
      api.rerender('1f46f11c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VPL/MyOrder/OrderDetail/OrderShipmentCreate.vue"
export default component.exports